import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=44c80ac3&scoped=true&"
import script from "./SettingsList.vue?vue&type=script&lang=js&"
export * from "./SettingsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=44c80ac3&prod&lang=scss&scoped=true&"
import style1 from "./SettingsList.vue?vue&type=style&index=1&id=44c80ac3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c80ac3",
  null
  
)

export default component.exports